import Route from '@ember/routing/route';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

export default class SettingsLogsRoute extends Route {
	@service('navigation') declare navigationService: Service.Navigation;
	@service('current-user') declare currentUserService: Service.CurrentUser;

	override beforeModel() {
		document.body.id = 'page-activity-log';

		if (!this.currentUserService.isAdmin) {
			this.navigationService.transitionToRoute('settings.users');
		}
	}
}
